module.exports = "/_next/static/images/616238dced217ddcd7e2501962654128-mulher-perfil-segurando-cartao-lg@1x.jpg.webp";